"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyCalendar = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const hooks_1 = require("../../../store/hooks");
const movingStreamSelectors_1 = require("../../../store/movingStreamSelectors");
const Month_1 = require("./atoms/Month");
const S = __importStar(require("./Calendar.style"));
const HeaderToggle_1 = __importDefault(require("./HeaderToggle/HeaderToggle"));
const EmptyCalendar = ({ onDayClick }) => {
    const threeMonthsData = (0, hooks_1.useAppSelector)(movingStreamSelectors_1.selectEmptyCalendarData);
    const { t } = (0, react_i18next_1.useTranslation)();
    const [selectedTimestamp, setSelectedTimestamp] = (0, react_1.useState)(null);
    const handleDayClick = (0, react_1.useCallback)((timestamp) => {
        setSelectedTimestamp(timestamp);
        onDayClick === null || onDayClick === void 0 ? void 0 : onDayClick(timestamp);
    }, [onDayClick]);
    const monthComponents = (0, react_1.useMemo)(() => {
        if (!threeMonthsData)
            return null;
        return threeMonthsData.map((month) => (react_1.default.createElement(Month_1.Month, Object.assign({ key: month.monthName }, month, { onDayClick: handleDayClick, selectedTimestamp: selectedTimestamp }))));
    }, [threeMonthsData, handleDayClick, selectedTimestamp]);
    if (!threeMonthsData)
        return null;
    return (react_1.default.createElement(S.CalendarContainer, null,
        react_1.default.createElement(HeaderToggle_1.default, { titleText: t("calendarHeader.calendarTitle"), componentToToggle: react_1.default.createElement(S.ThreeMonths, null, monthComponents) })));
};
exports.EmptyCalendar = EmptyCalendar;
